module.exports = __webpack_public_path__ + "static/img/GSK-Rare-CRS.4341684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/GSK-Rare-CRS.png
// module id = hwph
// module chunks = 0